(ns minorodata.components.pipeline-editor.details.analytics-models
  (:require
   ["lucide-react" :refer [ExternalLink]]
   ["react" :as react]
   [minorodata.app.handlers :refer [dispatch dispatch-sync]]
   [minorodata.components.log.table :refer [logs-row]]
   [minorodata.components.pipeline-editor.details.utils :refer [selected-node-bar]]
   [minorodata.components.spinner.core :as spinner]
   [minorodata.logs.model :refer [->logs-view]]
   [re-frame.core :as re-frame]
   [re-posh.core :as re-posh]
   [reitit.frontend.easy :as rt.easy]
   [ui.button :as button]
   [ui.table :refer [table tbody th thead tr]]
   [ui.typography :as typography]))


(def log-params
  {:items-per-page 50
   :page 0})


(defn recent-logs' [{:keys [instance timezone logs loading?]}]
  (react/useEffect
   (fn []
     (dispatch [:logs-view/add (->logs-view (assoc log-params :term (:analytics-model/name instance)))
                {:replace true}])
     (dispatch [:logs.api/fetch])
     (fn []
       (dispatch-sync [:logs-view/delete])))
   #js [(:analytics-model/name instance)])

  (cond
    loading?
    [:div {:class "flex gap-2 items-center px-10 py-6"}
     [spinner/spinner-lucide] "Loading logs..."]

    (empty? logs)
    [typography/p {:class "text-kleene-text-secondary px-10 py-6"} "No recent logs"]

    :else
    [table {:data-cy       "logs-table"
            :sticky-header true}
     [thead
      [tr {:sticky true}
       [th {:style {:width "180px" :height "52px"}
            :class "border-r"}
        [:span "Date"
         [:div {:class "-mt-1"}
          [:span {:class "text-xs text-kleene-dark-05 dark:text-kleene-dark-03"} timezone]]]]
       [th {:style {:width "80px"} :class "border-r"} "Type"]
       [th {:class "border-r"} "Message"]
       [th {:style {:width "80px"}} "Task"]]]
     [tbody {}
      (for [message-id logs]
        ^{:key message-id}
        [logs-row {:message-id   message-id
                   :skip-columns ["source-name" "name"]
                   :interactive  false}])]]))


(defn recent-logs [{:keys [instance]}]
  (let [logs     @(re-posh/subscribe [:logs-pager/prop :logs-pager/messages])
        loading? @(re-posh/subscribe [:mold-http/loading? :logs.api/fetch])
        timezone @(re-posh/subscribe [:app/prop :app/timezone])
        sandbox? @(re-posh/subscribe [:sandbox.subs/enabled?])]
    [:f> recent-logs' {:instance instance
                       :logs     logs
                       :loading? loading?
                       :timezone timezone
                       :sandbox? sandbox?}]))


;; A graph node is keyed by the model's master-id, but an instance page is
;; addressed by its per-version model-id. The node's on-click stashes that
;; model-id in the generic per-type preview slot (:tab-preview-node-metadata-id),
;; so rather than load the instance in-panel we link to its full instance page.
(defn analytics-model-details [{:keys [selected]}]
  (let [query    @(re-frame/subscribe [:app-route/prop :app-route/query])
        model-id (:tab-preview-node-metadata-id query)]
    [:div {:class "grid h-full grid-rows-[auto_1fr] overflow-hidden"}
     [selected-node-bar {:selected selected}]
     [:div {:class "flex flex-col gap-4 items-center justify-center h-full px-10 text-center"}
      [typography/h2 "Analytics model instance"]
      [typography/p {:class "text-kleene-text-secondary max-w-md"}
       "Open this instance to view and edit its configuration, schedule and run history."]
      (if model-id
        [button/button {:variant :primary
                        :icon    ExternalLink
                        :href    (rt.easy/href :analytics-model-instance-details {:instance-id model-id})}
         "Open model instance"]
        [typography/p {:class "text-kleene-text-secondary"}
         "This model instance is no longer available."])]]))
